import type { FaireProductEntity } from "../../entity_types/product";

export const p_cskq2755cu: FaireProductEntity = {
  token: "p_cskq2755cu",
  type: "product",
  name: 'Tight Optic Cocktail Coupe-6"H(8oz)',
  brandToken: "b_a8n58zvndo",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.faire.com/fastly/2fad5b1308cf3f3225cc7bdee3a55e02eb25b8605b81dd07994083e6c20cd896.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/72baec04ce8c17c0c1d212ef5d04d15d725c8e9c106c644de37aa61b2fc2d7d5.jpeg",
    "https://cdn.faire.com/fastly/60420c31f2bbceeff2d44d653bad4e821fa4fea6c73cf258bc24b61e069f8385.jpeg",
  ],
  priceDollars: 7.5,
  description:
    "Give your dinner party the glassware it deserves with this Tight Optic Cocktail Coupe. Crafted out of specialized reflective glass with intricate line detailing, this piece is sure to be the star of any entertaining occasion. Also available in other styles.",
  tags: [],
  msrpDollars: 15,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T19:58:08.143Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
